export type Profile = {
  id: string;
  name: string;
  initial: string;
  color: string;
  creature: string;
  vibe: string;
  score: number;
  bot?: boolean;
  left?: boolean;
};

export type MsgKind = "chat" | "hq" | "system";

export type Message = {
  id: string;
  from: string;
  kind: MsgKind;
  text: string;
  at: number;
};

export type RoomState = {
  room: string;
  members: Profile[];
  messages: Message[];
  fridge: string[];
  game: import("./rules").GameState;
};

export const STARTER_FRIDGE = ["don’t tell Mom", "juice (emotional)", "who moved the remote"];

export const NAMES = [
  "Tater",
  "Bub",
  "Nana",
  "Beans",
  "Junior",
  "MooMoo",
  "Pickle",
  "Deb",
  "Jay",
  "Gigi",
  "Bo",
  "Clem",
  "Soso",
  "Pip",
];

export const CREATURES = [
  "snack scientist",
  "aux goblin",
  "couch mayor",
  "sauce historian",
  "group-chat gremlin",
  "fridge lawyer",
  "honorary dog",
  "minivan DJ",
];

export const VIBES = [
  "here to lol",
  "saving you a seat",
  "already in the group chat",
  "brought juice and chaos",
  "not doing the dishes",
  "family HQ forever",
];

export const COLORS = ["#0b84ff", "#34c759", "#ff9f0a", "#ff375f", "#bf5af2", "#64d2ff", "#ffd60a", "#ac8e68"];

export const COMMON_ROOM = "family-hq";
